import { useState, useEffect } from 'react';
import { getFirestore, doc, setDoc, onSnapshot, serverTimestamp } from 'firebase/firestore';
import { useAuth } from '../Authcontext';

const firestore = getFirestore();

export const useCourseProgress = (courseId) => {
  const { currentUser } = useAuth();
  const [progress, setProgress] = useState({
    currentLessonIndex: 0,
    maxLessonReachedIndex: 0,
    checklist: {}
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser?.uid || !courseId) {
      setLoading(false);
      return;
    }

    const docRef = doc(firestore, 'users', currentUser.uid, 'course_progress', courseId);

    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setProgress({
          currentLessonIndex: data.currentLessonIndex || 0,
          maxLessonReachedIndex: data.maxLessonReachedIndex || 0,
          checklist: data.checklist || {}
        });
      }
      setLoading(false);
    }, (error) => {
      console.error("Error fetching course progress:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser, courseId]);

  const updateLesson = async (index) => {
    if (!currentUser?.uid) return;

    const newMax = Math.max(progress.maxLessonReachedIndex, index);
    
    // Optimistic update
    setProgress(prev => ({
        ...prev,
        currentLessonIndex: index,
        maxLessonReachedIndex: newMax
    }));

    const docRef = doc(firestore, 'users', currentUser.uid, 'course_progress', courseId);
    await setDoc(docRef, {
      currentLessonIndex: index,
      maxLessonReachedIndex: newMax,
      lastAccessed: serverTimestamp()
    }, { merge: true });
  };

  const updateChecklist = async (itemId, isChecked) => {
    if (!currentUser?.uid) return;

    const newChecklist = { ...progress.checklist, [itemId]: isChecked };

    // Optimistic update
    setProgress(prev => ({
        ...prev,
        checklist: newChecklist
    }));

    const docRef = doc(firestore, 'users', currentUser.uid, 'course_progress', courseId);
    await setDoc(docRef, {
      checklist: newChecklist,
      lastAccessed: serverTimestamp()
    }, { merge: true });
  };

  return {
    progress,
    loading,
    updateLesson,
    updateChecklist
  };
};
